import deepMerge from 'deepmerge';
import { theme as defaultChartTheme } from '../theme';
export var extendTheme = function (customTheme) {
    if (customTheme === void 0) { customTheme = {}; }
    return deepMerge(defaultChartTheme, customTheme, {
        arrayMerge: function (_target, source) { return source; },
    });
};
